import { useEffect, useState } from "react";
import { Expand } from "lucide-react";
import PhotoLightbox from "@/components/PhotoLightbox";
import "@/Gallery.css";
import { useLanguage } from "@/i18n";
import Seo from "@/Seo";

export default function GalleryPage() {
  const { language, t } = useLanguage();
  const [photos, setPhotos] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetch("/gallery.json").then(response => response.json()).then(setPhotos).catch(() => setPhotos([]));
  }, []);

  const getCaption = (photo) => photo.captions?.[language] || photo.title || photo.alt;
  return <>
    <Seo title={t("nav.gallery")} path="/gallery" />
    <section className="gallery-header" data-testid="gallery-page-header"><div className="shell"><span className="eyebrow" data-testid="gallery-eyebrow">{t("gallery.kicker")}</span><h1 data-testid="gallery-title">{t("gallery.title")}</h1></div></section>
    <section className="shell gallery-section" data-testid="gallery-section"><div className="gallery-grid" data-testid="gallery-grid">{photos.map(photo => <button className="gallery-tile" key={photo.id} onClick={() => setSelected(photo)} data-testid={`gallery-photo-${photo.id}`} aria-label={getCaption(photo)}><img src={photo.src} alt={photo.alt} /><span><Expand size={20} /></span></button>)}</div></section>
    <PhotoLightbox photo={selected} onClose={() => setSelected(null)} />
  </>;
}